type AlertModalType = 'Active Alert' | 'Historical Alert' | 'New Alert' | 'Scheduled Alert' | undefined;
type ConfirmationDialogAction = 'Delete' | 'Disable';
type PrimaryAction = 'Create Alert' | 'Save Alert' | 'Update Alert';
type TextButtonAction = 'Delete Alert' | 'Disable Alert' | 'Duplicate Alert';

enum AlertType {
  Info = 'Info',
  Warning = 'Warning',
  Incident = 'Incident',
  Promotion = 'Promotion',
}

enum GridColumns {
  Date = 'Scheduled Date/Time',
  Text = 'Alert Text',
  Type = 'Alert Type',
  AlertArea = 'Alert Area',
  Cta = 'CTA',
  Delete = 'Delete',
  UserVisibility = 'Show To Unauthorized Users',
}

export type { AlertModalType, ConfirmationDialogAction, PrimaryAction, TextButtonAction };
export { AlertType, GridColumns };
